module.exports = __webpack_public_path__ + "img/jm2020.d3fc25bf.png";